import React, { useState } from 'react';
import * as S from './styles';
import { Divider } from '../styles';
import Icon, { IconType } from 'components/Icon';
import { useTheme } from 'styled-components';
import { Tooltip } from 'components/Widget/Tooltip';

export interface FrameDetailsSectionProps {
	label: string;
	children?: React.ReactNode | React.ReactNode[];
	actions?: FrameDetailsSectionAction[];
}

export interface FrameDetailsSectionAction {
	tooltip: string;
	icon: IconType;
	onClick: () => void;
}

const FrameDetailsSection = ({ label, children, actions }: FrameDetailsSectionProps) => {
	const theme = useTheme();
	const [tooltipId] = useState(String(Math.random()));

	return (
		<>
			<S.DividerWrapper>
				<Divider />
			</S.DividerWrapper>
			<S.Base>
				<S.Header>
					<S.Label>{label}</S.Label>
					<S.Actions>
						{actions?.map((action, i) => (
							<React.Fragment key={i}>
								<S.Action
									data-tooltip-id={tooltipId + i}
									data-tooltip-content={action.tooltip}
									onClick={action.onClick}
								>
									<Icon type={action.icon} width={16} height={16} color={theme.gray[1000]} />
								</S.Action>
								<Tooltip id={tooltipId + i} placement="top" />
							</React.Fragment>
						))}
					</S.Actions>
				</S.Header>
				<S.Children>{children}</S.Children>
			</S.Base>
		</>
	);
};

export default FrameDetailsSection;
